import { Modal } from "@material-ui/core";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../App.css";
import Loginpopup from "../../Navbar/Loginmodal";
import Googleplay from "./image/Googleplay.png";
import Applestore from "./image/appdownloads.png";
import './../../Footer/Footer.css';
import FloatingLabelInput from "./BookingForm/FloatingLabelInput";
import FloatingLabelSelect from "./BookingForm/FloatingLabelSelect";
import './BookingForm/PartyForm.css';
import './BookingForm/Feed.css'
import './BookingForm/FloatingLabelInput.css';
import './BookingForm/FloatingLabelSelect.css';



import iziToast from "izitoast";
import Loader from "../../Loader/Loader";



function PackageLaedFormComp({ clubId, selectedLead }) {

    const [alcoPacks, setAlcoPacks] = useState([]);
    const [nonAlcoPacks, setNonAlcoPacks] = useState([]);

    const getPackTitles = async (type) => {
        if (!type) return [];

        const formData = new FormData();
        formData.append("type", type);

        try {
            const response = await axios.post(
                "https://partywitty.com/master/Api/getDataPost/AllPackageTitle",
                formData
            );

            return response?.data?.data || [];
        } catch (error) {
            console.error("Error fetching package titles:", error);
            return [];
        }
    };

    useEffect(() => {
        const loadPackages = async () => {
            const aPacks = await getPackTitles("Alcoholic");
            const naPacks = await getPackTitles("Non-Alcoholic");

            setAlcoPacks(aPacks);
            setNonAlcoPacks(naPacks);
        };

        loadPackages();
    }, []);

    const getPackType = (title) => {
        if (alcoPacks.some((pack) => pack.name === title)) {
            return "Alcoholic";
        }
        if (nonAlcoPacks.some((pack) => pack.name === title)) {
            return "Non-Alcoholic";
        }
        return undefined;
    };



    const [userdata, setUserData] = useState(JSON.parse(localStorage.getItem("userData")));
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [apiData, setApiData] = useState(null);
    const [cityId, setCityId] = useState("");
    const [showPopup, setShowPopup] = useState(false);



    const [selectedArea, setSelectedArea] = useState(null);
    const [citydata, setCityData] = useState([]);
    const [selectedAreaid, setSelectedAreaid] = useState(null);
    const [location12, setLocation12] = useState(""); // Location state
    const [leadarea, setLeadarea] = useState([]);

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedVenu, setSelectedVenu] = useState([]);
    const [selectedTime, setSelectedTime] = useState(null);
    const [isReserved, setReserved] = useState(false);
    const [cancel, setCancel] = useState(false);

    const [packagetitle, setPackagetitle] = useState("");
    const [packagetitlelist, setPackagetitlelist] = useState([]);
    const [packtitle, setPacktitle] = useState("");
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState("");


    const searchParams = new URLSearchParams(location.search);
    const status = searchParams.get("status");

    const url = "https://partywitty.com/master/assets/uploads/";


    const venueTypeIds = selectedVenu.map((venue) => venue.id).join(",");


    const [formData, setFormData] = useState({
        club_id: "",
        whatsapp: userdata ? userdata.whatsapp : null,
        whatsapp_msg: "true",
        city_id: cityId,
        area_id: selectedArea ? selectedArea.id : "",
        male: "0",
        female: "0",
        kids: "0",
        party_date: "",
        party_time: "",
        lead_source: "website",
        user_id: userdata ? userdata.id : "",
        venue_type: '',
        requirement: "package",
        my_choice: "",
        type: "",
        name: "",
        email: "",
        mobile: "",
        occation: "",
        kids_friendly: "yes",
        latitude: selectedArea ? selectedArea.latitude : null,
        longitude: selectedArea ? selectedArea.longitude : null,
        range: "10km",
    });

    useEffect(() => {
        const updates = {
            city_id: cityId,
            area_id: selectedArea?.id || "",
            user_id: userdata?.id || "",
            venue_type: venueTypeIds,
            whatsapp: userdata?.whatsapp || "",
            latitude: selectedArea?.latitude || "",
            longitude: selectedArea?.longitude || "",
        };

        if (selectedLead) {
            if (selectedLead.party_date) updates.party_date = selectedLead.party_date;
            if (selectedLead.party_time) updates.party_time = selectedLead.party_time;
            if (selectedLead.male) updates.male = selectedLead.male;
            if (selectedLead.female) updates.female = selectedLead.female;
            if (selectedLead.kids) updates.kids = selectedLead.kids;
        }

        setFormData((prevState) => ({
            ...prevState,
            ...updates,
        }));

        const getPackagetype = getPackType(selectedLead?.title);
        if (getPackagetype) {
            setPackagetitle(getPackagetype);
            setFormData((prevData) => ({
                ...prevData,
                type: getPackagetype,
            }));
        }

    }, [cityId, selectedVenu, selectedLead, selectedArea, userdata]);




    useEffect(() => {
        if (!selectedLead || !apiData) return;

        const matchedCity = apiData.find(
            (city) => city.name.toLowerCase() === selectedLead.city?.toLowerCase()
        );

        if (matchedCity) {
            setCityId(matchedCity.id); // ✅ hidden id
            setLocation12(matchedCity.name); // ✅ shown name in dropdown
        }
    }, [selectedLead, apiData]);


    useEffect(() => {
        if (!selectedLead || !leadarea.length) return;

        const matchedArea = leadarea.find(
            (area) => area.name.toLowerCase() === selectedLead.area?.toLowerCase()
        );

        if (matchedArea) {
            setSelectedArea(matchedArea);
            setSelectedAreaid(matchedArea.id);
        }
    }, [selectedLead, leadarea]);


    useEffect(() => {
        if (selectedArea) {
            setFormData((prev) => ({
                ...prev,
                area_id: selectedArea.id,
                latitude: selectedArea.latitude,
                longitude: selectedArea.longitude,
            }));
        }
    }, [selectedArea]);


    useEffect(() => {
        if (!packagetitle) return;

        const formData = new FormData();
        formData.append("type", packagetitle);

        axios
            .post("https://partywitty.com/master/Api/getDataPost/AllPackageTitle", formData)
            .then((response) => {
                const packages = response.data.data || [];
                setPackagetitlelist(packages);

                // Update form type
                setFormData((prevData) => ({
                    ...prevData,
                    type: packagetitle,
                }));

                // ✅ Set selected package if it matches selectedLead.title
                if (selectedLead?.title) {
                    const matched = packages.find((item) => item.name === selectedLead.title);
                    if (matched) {
                        setPacktitle(matched.id); // ⬅️ assuming you're using valueKey="id"
                        setFormData((prevData) => ({
                            ...prevData,
                            my_choice: matched.name,
                        }));
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [packagetitle, selectedLead]);






    useEffect(() => {
        if (status === "success" && !isReserved) {
            setReserved(true);
        }
    }, [status, isReserved]);

    useEffect(() => {
        if (status === "failed" && !cancel) {
            setCancel(true);
        }
    }, [status, cancel]);

    const handleTimeSelection = (e) => {
        const { name, value } = e.target;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
        setSelectedTime(value);
    };

    const handleAreaChange = (e) => {
        const areaId = e.target.value;
        const matchedArea = leadarea.find((area) => area.id === areaId);

        if (matchedArea) {
            setSelectedArea(matchedArea); // ✅ this is what formData.area_id depends on
            setSelectedAreaid(matchedArea.id);
        }
    };




    const handleLocationChange = (e) => {
        const selectedName = e.target.value;
        setLocation12(selectedName); // ✅ show city name in dropdown

        const matchedCity = apiData.find((city) => city.name === selectedName);
        if (matchedCity) {
            setCityId(matchedCity.id); // ✅ use ID internally
        }
    };




    const handlePackageChange = (e) => {
        const selectedPackage = e.target.value;
        setPackagetitle(selectedPackage);

        if (selectedPackage) {
            const formData = new FormData();
            formData.append("type", selectedPackage);

            axios
                .post(
                    "https://partywitty.com/master/Api/getDataPost/AllPackageTitle",
                    formData
                )
                .then((response) => {
                    setPackagetitlelist(response.data.data);
                    // Update the type in formData
                    setFormData((prevData) => ({
                        ...prevData,
                        type: selectedPackage,
                    }));
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const handlePackagename = (e) => {
        const selectedPackTitle = e.target.value;
        setPacktitle(selectedPackTitle);
        setFormData((prevData) => ({
            ...prevData,
            my_choice: selectedPackTitle,
        }));
    };

    const handleSubmit = async (e) => {

         e?.preventDefault();

        if (!formData.party_date) {
            // toast.error("Please select a party date");
            iziToast.error({
                title: 'Error',
                message: 'Please select a party date',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (!formData.party_time) {
            // toast.error("Please select a party time");
            iziToast.error({
                title: 'Error',
                message: 'Please select a party time',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (formData.male === "" || formData.male < 0) {
            // toast.error("Enter a valid number of male guests");
            iziToast.error({
                title: 'Error',
                message: 'Enter a valid number of male guests',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (formData.female === "" || formData.female < 0) {
            iziToast.error({
                title: 'Error',
                message: 'Enter a valid number of female guests',
                position: 'topRight',
                timeout: 3000,
            });
            // toast.error("Enter a valid number of female guests");
            return;
        }

        if (formData.kids === "" || formData.kids < 0) {
            // toast.error("Enter a valid number of kids");
            iziToast.error({
                title: 'Error',
                message: 'Enter a valid number of kids',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (!formData.city_id || formData.city === "Select a city") {
            // toast.error("Please select a city");
            iziToast.error({
                title: 'Error',
                message: 'Please select a city',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (!selectedArea?.id) {
            // toast.error("Please select an area");
            iziToast.error({
                title: 'Error',
                message: 'Please select an area',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (!packagetitle || packagetitle === "Select a package") {
            // toast.error("Please select a package type");
            iziToast.error({
                title: 'Error',
                message: 'Please select a package type',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (!packtitle || packtitle === "") {
            // toast.error("Please select a package name");
            iziToast.error({
                title: 'Error',
                message: 'Please select a package name',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }


        const isAgreed = document.getElementById('agreeCheckbox').checked;

        if (!isAgreed) {
            // alert("You have accepted our terms and conditions");
            iziToast.error({
                title: 'Error',
                message: 'You have accepted our terms and conditions',
                position: 'topRight',
                timeout: 3000,
            });
            return;
        }

        if (userdata === null) {
            setShowLoginPopup(true);
            return false;
        } else {
            setShowLoginPopup(false);
        }
        // validate min-pax count
        const MIN_PAX = 10;
        const pax = Number.parseInt(formData.male || '0') + Number.parseInt(formData.female || '0');
        if (pax < MIN_PAX) {
            alert(`A minimum of ${MIN_PAX} adult guests are required for booking.`);
            return;
        }

        const fd = Object.entries(formData);
        const formDataObj = new FormData();
        fd.forEach(([key, value]) => {
            formDataObj.append(key, value);
        });

        setLoading(true);

        try {
            const response = await axios.post(
                "https://partywitty.com/master/APIs/ClubPackage/submitEnquiry",
                formDataObj
            );

            if (response.data.status === true) {
                iziToast.success({
                    title: 'Success',
                    message: 'Form submitted successfully',
                    position: 'topRight',
                    timeout: 3000,
                });
                 setShowPopup(true);
                window.location.href = '/package-lead-submitted';
                document.getElementById('agreeCheckbox').checked = false;

            } else {
                alert(response.data.msg);
                // window.location.reload();
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        axios
            .get("https://partywitty.com/master/APIs/ClubPackage/getVenuType")
            .then((response) => {
                const clubCategories = response.data.data;
                setSelectedVenu(clubCategories);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        const apiUrl = "https://partywitty.com/master/Api/getDataPost/AreaLead";
        if (cityId) {
            const formData = new FormData();
            formData.append("city_id", cityId);
            axios
                .post(apiUrl, formData)
                .then((response) => {
                    setLeadarea(response.data.data);
                })
                .catch((error) => {
                    console.error("API error:", error);
                });
        }
    }, [cityId]);

    useEffect(() => {
        axios
            .get("https://partywitty.com/master/Api/getData/getAreaLead")
            .then((response) => {
                setCityData(response.data.data);
            })
            .catch((error) => {
                console.log("Error fetching area data:", error);
            });
    }, []);

    useEffect(() => {

        const firstApiUrl =
            "https://partywitty.com/master/Api/getDataPost/countryWiseState";
        const formData = new FormData();
        formData.append("country_id", "101");
        const combinedData = [];
        axios
            .post(firstApiUrl, formData)
            .then((response) => {

                const stateIds = response.data.data
                    .filter(
                        (item) =>
                            item.id === "4007" || item.id === "4021" || item.id === "4022"
                    )
                    .map((item) => item.id);


                const secondApiUrl =
                    "https://partywitty.com/master/Api/getDataPost/stateWiseCity";


                const secondPostPromises = stateIds.map((stateId) => {
                    const formData = new FormData();
                    formData.append("state_id", stateId);
                    return axios.post(secondApiUrl, formData);
                });


                return Promise.all(secondPostPromises);
            })
            .then((responses) => {

                responses.forEach((response) => {
                    combinedData.push(...Array.from(response.data.data));
                });


                const filteredData = combinedData.filter((item) =>
                    [
                        "134404",
                        "134007",
                        "133234",
                        "131821",
                        "58171",
                        "132032",
                        "131853",
                        "133230",
                        "132005",
                        "131953",
                    ].includes(item.id)
                );

                setApiData(filteredData);
            })
            .catch((error) => {
                console.error("API error", error);
            });
    }, []);





    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const [selectedVenues, setSelectedVenues] = useState([]);

    const handleDateSelection = (data, type) => {
        if (type === "date") {

            const isAlreadySelected = selectedVenues.some(
                (venue) => venue.id === data.id
            );



            if (isAlreadySelected) {

                setSelectedVenues((prevVenues) =>
                    prevVenues.filter((venue) => venue.id !== data.id)
                );
            } else {

                setSelectedVenues((prevVenues) => [...prevVenues, data]);
            }
        } else {

        }
    };

    const [doSubmit, setDoSubmit] = useState(false);

    useEffect(() => {
        if (doSubmit && userdata.id) {
            console.log('Submit Lead: ', doSubmit, userdata);
            handleSubmit();
            setDoSubmit(false);
        }
    }, [doSubmit,]);

    const handleLogin = async (ud) => {
        if (ud) {
            setFormData((prevState) => ({
                ...prevState,
                user_id: ud.id,
                whatsapp: ud.whatsapp,
            }));
            setUserData(ud);
            setShowLoginPopup(false);

            // attempt to submit the form again
            setDoSubmit(true);
        }
    }

    const handleDateChange = (e) => {
        const selected = e.target.value;
        const today = new Date().toISOString().split("T")[0];

        if (selected < today) {
            alert("Past dates are not allowed.");
            return;
        }

        setFormData((prev) => ({
            ...prev,
            party_date: selected,
        }));

        setSelectedDate(selected);
        handleDateSelection(selected, "date");
    };


    const alcoholicOptions = [{ id: 1, name: "Alcoholic" }, { id: 2, name: "Non-Alcoholic" }]


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const [activeTab, setActiveTab] = useState("package");



    const GroupParty = (
        <div className="pplf-form-container">
            <form onSubmit={handleSubmit} className="party-form">
                <FloatingLabelInput
                    type="date"
                    name="party_date"
                    label="Party Date"
                    value={formData.party_date}
                    onChange={handleDateChange}
                    min={new Date().toISOString().split("T")[0]}
                // required
                />


                <FloatingLabelInput
                    type="time"
                    name="party_time"
                    label="Party Time"
                    value={formData.party_time}
                    onChange={handleTimeSelection}
                />


                <div>
                    <div className="guest-group">
                        <div className="guest-g-input">

                            <FloatingLabelInput
                                type="number"
                                name="male"
                                label="Male Guests"
                                value={formData.male}
                                onChange={handleInputChange}
                                // required
                                min="0"
                                defaultValue={0}
                            />
                            <span className="small-text-form">21years and above</span>
                        </div>

                        <div>
                            <FloatingLabelInput
                                type="number"
                                name="female"
                                value={formData.female}
                                label="Female Guests"
                                onChange={handleInputChange}
                                defaultValue={0}
                                // required
                                min="0"
                            />
                            <span className="small-text-form">21years and above</span>
                        </div>

                    </div>
                </div>


                <div>
                    <FloatingLabelInput
                        type="number"
                        name="kids"
                        label="Kids"
                        value={formData.kids}
                        onChange={handleInputChange}
                        defaultValue={0}
                        // required
                        min="0"
                    />
                    <span className="small-text-form">5 years & below</span>
                </div>


                {/* <span className='small-text-form'>5 years & below</span> */}

                <div className="dropdown-group">
                    <FloatingLabelSelect
                        label="City"
                        name="city"
                        value={location12}
                        onChange={handleLocationChange}
                        options={[
                            { id: "", name: "Select a city" }, // placeholder option
                            ...citydata
                        ]}
                        valueKey="name"
                    />


                    <FloatingLabelSelect
                        name="area"
                        label="Area"
                        value={selectedArea ? selectedArea.id : ""}
                        onChange={handleAreaChange}
                        options={[{ id: "", name: "Select a area" }, ...leadarea]}
                        valueKey="id"
                    />
                </div>


                <div className="dropdown-group">

                    <FloatingLabelSelect
                        label="Package Type"
                        value={packagetitle}
                        onChange={handlePackageChange}
                        options={[{ id: "", name: "Select a package" }, ...alcoholicOptions]}
                        valueKey="name"
                    />

                    <FloatingLabelSelect
                        name="packagename"
                        label="Package Name"
                        value={packtitle}
                        onChange={handlePackagename}
                        options={[{ id: "", name: "Select a package" }, ...packagetitlelist]}
                        valueKey="id"
                    />
                </div>

                <div>
                    <FloatingLabelInput
                        type="textarea"
                        name="instructions"
                        label="Please type here"
                        value={formData.instructions}
                        onChange={handleChange}
                    />
                    <div className="checkbox">
                        <input
                            type="checkbox"
                            id="agreeCheckbox" // ✅ add an ID
                            name="agree"
                            checked={formData.agree}
                            onChange={handleChange}
                        />

                        <span style={{ color: "black" }}>
                            I agree to the  <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
                            <Link to="/term-conditions-policy">Terms & Condition</Link>.
                        </span>
                    </div>
                </div>


                <button type="submit">{selectedLead ? "Update Lead" : "Reserve Now"}</button>
            </form>

            {/* Success Modal */}
            <Modal
                open={showPopup}
                onClose={() => {
                    setShowPopup(false);
                    window.location.href = '/';
                }}
            >
                <div className="modal-container">
                    <div className="modal-content">
                        <button
                            className="modal-button"
                            onClick={() => {
                                setShowPopup(false);
                                window.location.href = '/';
                            }}
                        >
                            x
                        </button>
                        <dotlottie-player
                            src="https://lottie.host/6b9fc96a-5c59-464a-ad26-5782e3a54022/EFWiS28KVM.json"
                            background="transparent"
                            speed="1"
                            style={{ height: "300px" }}
                            loop
                            autoplay
                        ></dotlottie-player>
                        <p className="modal-message">Form submitted successfully!</p>
                        <div className="about-us-playstore-image">
                            <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                <img src={Googleplay} alt="playstore" />
                            </Link>
                            <Link to="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                                <img src={Applestore} alt="appstore" />
                            </Link>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>

    )


    return (
        <>
            {loading && <Loader />}
            <div>
                {showLoginPopup && <Loginpopup clbk={handleLogin} />}
                <div >
                    {GroupParty}
                </div>
            </div>
        </>
    );
}

export default PackageLaedFormComp;

